var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { I18NLink } from "../../I18N";

import { Icon } from "../../Layout";
import * as actions from "../../Relationships/actions/actions";





const mapStateToProps = ({ entityView }) => ({
  uiState: entityView.uiState
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
  {
    selectConnection: actions.selectConnection
  },
  dispatch);

}

const connector = connect(mapStateToProps, mapDispatchToProps);



const RelationshipLink = ({ propValue: propVal, selectConnection }) => {
  if (propVal.relatedEntity) {
    return /*#__PURE__*/(
      _jsx("button", {
        type: "button",
        className: "link-button",
        onClick: () => selectConnection(propVal.relatedEntity) },
      propVal.url,

      propVal.icon && /*#__PURE__*/_jsx(Icon, { className: "item-icon", data: propVal.icon }),
      propVal.value));


  }
  return /*#__PURE__*/(
    _jsx(I18NLink, { to: propVal.url }, propVal.url,
    propVal.icon && /*#__PURE__*/_jsx(Icon, { className: "item-icon", data: propVal.icon }),
    propVal.value));


};

const container = connector(RelationshipLink);
export { container as RelationshipLink };